// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import ToastPropsDefault, { toasterProps as toasterPropsDefault } from "@insite/mobius/Toast/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import AlertError from "@keller/XDL/Icons/AlertError";
import AlertInfo from "@keller/XDL/Icons/AlertInfo";
import AlertSuccess from "@keller/XDL/Icons/AlertSuccess";
import AlertWarning from "@keller/XDL/Icons/AlertWarning";
import { buttonTransparent } from "@keller/XDL/PreStyle/button";
import { xBaseTheme } from "@keller/XDL/types";
import { color } from "@keller/XDL/Utilities";
import { css, ThemeProps } from "styled-components";

export default {
    defaultProps: {
        ...ToastPropsDefault,
        closeButtonProps: {
            mergeCss: true,
            color: "transparent",
            buttonType: "solid",
            shape: "pill",
            css: css`
                position: absolute;
                top: 0;
                right: 0;
                border: 0;
                width: 24px;
                height: 24px;
                padding: 0;
                ${buttonTransparent}
                &:hover ${IconWrapper} {
                    color: ${color("common.ui8")};
                }
            `,
            size: 24,
        },
        closeButtonIconProps: {
            mergeCss: true,
            src: "X",
            size: 12,
            color: "common.ui6",
        },
        iconProps: {
            mergeCss: true,
            size: 18,
            css: css`
                margin-right: 10px;
            `,
        },
        iconSrcByMessage: {
            success: AlertSuccess,
            warning: AlertWarning,
            danger: AlertError,
            info: AlertInfo,
        },
        bodyTypographyProps: {
            mergeCss: true,
            css: css`
                & > ${TypographyStyle}, & > div > ${TypographyStyle} {
                    ${({ theme }: ThemeProps<BaseTheme>) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    font-size: 12px;
                                    line-height: 16px;
                                `,
                                null,
                                css`
                                    font-size: 14px;
                                    line-height: 18px;
                                `,
                                null,
                                null,
                            ],
                            "min",
                        )}

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            `,
            color: "text.main",
        },
        cssOverrides: {
            toast: css`
                border-style: solid;
                border-width: 1px;
                background: ${({ messageType }: any) => color(`${messageType}.light`)};
            `,
            toastBody: css`
                &&& {
                    margin: 0;
                }
                align-items: flex-start;
                padding: 14px 12px;
            `,
        },
    },
    toasterProps: {
        ...toasterPropsDefault,
    },
} as xBaseTheme["toast"];
